import { render, staticRenderFns } from "./basepeople.vue?vue&type=template&id=e00ac7ea&scoped=true"
import script from "./basepeople.vue?vue&type=script&lang=js"
export * from "./basepeople.vue?vue&type=script&lang=js"
import style0 from "./basepeople.vue?vue&type=style&index=0&id=e00ac7ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e00ac7ea",
  null
  
)

export default component.exports